import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BoiFilingsDialogComponent } from "./boi-filings-dialog/boi-filings-dialog.component";
import { MatDialogModule } from "@angular/material/dialog";
import { MatTableModule } from "@angular/material/table";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { StatusDialogComponent } from './status-dialog/status-dialog.component';
import { TranscriptErrorDialogComponent } from './transcript-error-dialog/transcript-error-dialog.component';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@NgModule({
  declarations: [
    BoiFilingsDialogComponent,
    StatusDialogComponent,
    TranscriptErrorDialogComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
})
export class BoiFilingsModule {}
